import { render, staticRenderFns } from "./RoomObjectDisplayer.vue?vue&type=template&id=199d9bf5&scoped=true"
import script from "./RoomObjectDisplayer.vue?vue&type=script&lang=ts"
export * from "./RoomObjectDisplayer.vue?vue&type=script&lang=ts"
import style0 from "./RoomObjectDisplayer.vue?vue&type=style&index=0&id=199d9bf5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199d9bf5",
  null
  
)

export default component.exports